module.exports = __webpack_public_path__ + "img/民法.e52beb33.png";